// extracted by mini-css-extract-plugin
export default {"container":"MobileHeader_container__W6ZtY"};